import { motion } from "framer-motion";

const WORDS = "Travel the world of Belly Dance";

export const Marquee = () => {
  const items = Array.from({ length: 6 });
  return (
    <section
      data-testid="marquee-section"
      className="relative overflow-hidden border-y border-espresso/15 bg-champagne py-8 md:py-12"
    >
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 28, ease: "linear", repeat: Infinity }}
      >
        {items.concat(items).map((_, i) => (
          <span
            key={i}
            className="mx-8 font-serif text-5xl italic tracking-tight md:text-7xl lg:text-8xl text-outline"
          >
            {WORDS} <span className="not-italic text-gold" style={{ WebkitTextStroke: "0" }}>✦</span>
          </span>
        ))}
      </motion.div>
    </section>
  );
};
